<template>
  <div :style="{width :width+'px'}">
    <div v-if="showLabel">
      <div v-if="utils.string.vNotEmpty(label)">
        <line-overflow :content="label" :max-lines="1"></line-overflow>
      </div>
      <div v-else>
        <br>
      </div>
    </div>
    <div class="slot">
      <slot></slot>
    </div>
  </div>
</template>

<script>

import LineOverflow from "@/components/base/layout/text/LineOverflow.vue";
import {utils} from "@/util/utils";

export default {
  name: 'InputItem',
  computed: {
    utils() {
      return utils
    }
  },
  components: {LineOverflow},
  props: {
    label: String,
    default: "",
    width: String,
    showLabel: {
      type: Boolean,
      default: true
    },

  },


};
</script>

<style scoped>
.slot {
  margin-top: 4px;
}

.slot > * {
  width: 100%;
}

.line-overflow {
  min-height: 1.2em; /* 调整这个值以匹配您的实际行高 */
}


</style>
